import { combineReducers } from '@reduxjs/toolkit';

import { createIsolatedReducer } from 'Core/reducers/common';

import defaultSuggestions from './defaultSuggestions';
import helpers from './helpers';
import redirect from './redirect';
import request from './request';
import response from './response';

export default createIsolatedReducer(
  null,
  combineReducers({
    defaultSuggestions,
    redirect,
    request,
    response,
    ...helpers,
  }),
);
